import { useEffect, useRef, useState } from "react";
import { viewListDataForm, passwordResetFormData } from "../data/AccountManagementConfig";
import { decryptAESID } from "../../../utils/Encryption";
import SwalAlert from "../../../services/swalService/SwalService";
import FormCreator from "../../../components/Forms/FormCreator";
import Buttons from "../../../components/ui/button/Buttons";
import { useAddEditAdminDetailsMutation, useLazyGetAdminDetailByIdQuery, useLazyGetSignUpDropDownsForCorporateMembersQuery, useChangePasswordForAdminMutation } from "../../../app/services/common/commonApi";
import { setAllDropDownField } from "../utils/dropdownUtils";
import ToastService from "../../../services/toastService/ToastService";

const EditViewAccount = (props) => {
    const viewListDataRef = useRef();
    const resPasswordDataRef = useRef();
    const selectedId = props.selectedId ? decryptAESID(props.selectedId) : 0;
    const [viewList, setViewList] = useState(viewListDataForm)
    const [resetPasswordFormData, setResetPasswordFormData] = useState(passwordResetFormData)
    const { success, error } = SwalAlert();
    const [getAdminDetailById, { isSuccess: isSuccessAdminDetailsById, isFetching: isFetchingAdminDetailbyID, data: AdminDeatlisData }] = useLazyGetAdminDetailByIdQuery();
    const [addEditDetails, { isSuccess: isSuccesAddEditDetail, isFetching: isFetchingAddEditDetail, data: addEditAdminDetailsResponse }] = useAddEditAdminDetailsMutation();
    const [getAllDropDowns, { isSuccess: isGetAllDropDownFetched, isLoading: isGetDropDownFetching, data: allDropDownResponse },] = useLazyGetSignUpDropDownsForCorporateMembersQuery();
    const [changePasswordForAdmin, { isSuccess: isSuccessChangePasswordForAdmin, isFetching: isFetchingChangePasswordForAdmin, data: changePasswordForAdminResponse }] = useChangePasswordForAdminMutation();

    useEffect(() => {
        if (selectedId) {
            getAdminDetailById(selectedId);
        }
        getAllDropDowns();
    }, []);
    
    useEffect(() => {
        if (isSuccessChangePasswordForAdmin && !isFetchingChangePasswordForAdmin && changePasswordForAdminResponse) {
            if (changePasswordForAdminResponse) {
                ToastService.success("Password changed successfully.");
                props?.openCloseModal();
            }
        }
    }, [isSuccessChangePasswordForAdmin, isFetchingChangePasswordForAdmin, changePasswordForAdminResponse])

    useEffect(() => {
        if (!isGetDropDownFetching && isGetAllDropDownFetched && allDropDownResponse) {
            setAllDropDownField(allDropDownResponse);
        }
    }, [isGetDropDownFetching, isGetAllDropDownFetched, allDropDownResponse]);


    useEffect(() => {
        if (!isFetchingAddEditDetail && isSuccesAddEditDetail && addEditAdminDetailsResponse) {
            if (addEditAdminDetailsResponse.hasError === false) {
                success("Account Details Update Successfully")
                handleClear();
                props?.openCloseModal();
            }
            else {
                error(addEditAdminDetailsResponse.errorMessage)
            }
        }
    }, [isFetchingAddEditDetail, isSuccesAddEditDetail, addEditAdminDetailsResponse]);

    useEffect(() => {
        if (!isFetchingAdminDetailbyID && isSuccessAdminDetailsById && AdminDeatlisData) {
            let Data = { ...viewList }
            const { name, email, roleId,lastName } = AdminDeatlisData;
            Data.initialState = {
                firstName:name,
                email,
                roleId,
                lastName
            };
            setViewList(Data);
        }
    }, [isFetchingAdminDetailbyID, isSuccessAdminDetailsById, AdminDeatlisData]);

    const handleaUpdate = () => {
        const formData = viewListDataRef.current.getFormData();
        const request = {
            AdminID: AdminDeatlisData?.adminID || 0,
            Name: formData.firstName,
            LastName:formData.lastName,
            Email: formData.email,
            RoleId: formData.roleId.value || formData.roleId,
            CreatedBy: 115,
            CreatedAppId: 1
        }
        addEditDetails(request)
    }

    const handleResetPassword = () => {
        const formData = resPasswordDataRef?.current?.getFormData();

        if (!formData) {
            return;
        }
        if (formData.newPassword === formData.confirmNewPassword) {
            const request = {
                adminId: AdminDeatlisData?.adminID || 0,
                oldPassword: formData.oldPassword,
                newPassword: formData.newPassword,
                isActive: AdminDeatlisData?.isActive || true,
            }
            changePasswordForAdmin(request);
        }
    }


    const handleClear = () => {
        setViewList({
            ...viewListDataForm,
            initialState: {
                name: "",
                email: "",
                roleId: null,
            }
        });
    };

    return (<>
        {
            allDropDownResponse && (
                <>
                    <div className='mt-4'>
                        <FormCreator ref={viewListDataRef} {...viewList} />
                        <div className='col-lg-1 justify-content-start'>
                            <Buttons
                                buttonText="Update Account"
                                buttonTypeClassName="success-btn ml-2 mt-4"
                                onClick={handleaUpdate}
                            />
                        </div>

                    </div>
                    <div className=''>
                        <FormCreator ref={resPasswordDataRef} {...resetPasswordFormData} />
                        <div className='col-lg-1 justify-content-start'>
                            <Buttons
                                buttonText="Update Password"
                                buttonTypeClassName="success-btn ml-2 mt-4"
                                onClick={handleResetPassword}
                            />
                        </div>

                    </div>

                </>
            )
        }
    </>)
}

export default EditViewAccount;